import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-custom-toggle',
  templateUrl: './custom-toggle.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  styleUrls: ['./custom-toggle.component.scss']
})
export class CustomToggleComponent implements OnInit{
  @Input() vertical = false;
  @Input() active : boolean = false;
  @Input() init : boolean = false;
  @Input() disabled : boolean = false;
  @Output() activeChange = new EventEmitter<boolean>();

  ngOnInit() {
    this.active = this.init;
  }

  onCheckboxChange(){
    this.activeChange.emit(this.active);
  }
}
